// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const cosmoem: PokeData = {
  "id": 790,
  "name": "cosmoem",
  "height": 1,
  "weight": 9999,
  "base_experience": 140,
  "types": [
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "teleport",
    "cosmic-power"
  ],
  "moves": [
    "reflect",
    "prismatic-cage",
    "psychic-fangs",
    "psychic",
    "psychic-terrain",
    "healing-wish",
    "psywave",
    "future-sight",
    "psy-ball",
    "synchronize",
    "kinesis",
    "psy-pulse",
    "zen-headbutt"
  ],
  "evolution_chain": {
    "id": 413,
    "item": null,
    "species": [
      {
        "name": "cosmog",
        "order": 789,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "cosmoem",
        "order": 790,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 789,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 43,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "solgaleo",
        "order": 791,
        "types": [
          PokeType.PSYCHIC,
          PokeType.STEEL
        ],
        "evolves_from_species_id": 790,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 53,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "lunala",
        "order": 792,
        "types": [
          PokeType.PSYCHIC,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 790,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 53,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 87,
    "speed": 37,
    "ability_power": 29
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
